




import Vue from 'vue';
import home from '@/components/home/home.component.vue';

export default Vue.extend({
  components: {
    home: home,
  },
});
